import styled from 'styled-components';

export const StyledErrorCol = styled.div`
  line-height: normal;
`;

export const StyledProgressBar = styled.div`
  position: absolute;
  border: 4px solid #565655;
  border-radius: 4px;
  margin-bottom: 13px;
  width: 126px;
`;

export const StyledProgressPerc = styled.div`
  background: #02bf8e;
  content: '""';
  position: absolute;
  height: 8px;
  top: -4px;
  left: -4px;
  border-radius: 4px;
`;

export const StyledBtnContainer = styled.div`
  text-align: center;
  position: relative;
`;

export const StyledPercentage = styled.div`
  color: #02bf8e;
  position: absolute;
  bottom: -30px;
  left: 51px;
`;

export const StyledUploadBtnWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;
  & input[type='file'] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }
`;

export const StyledButton = styled.button`
  color: #ffffff;
  background: #565655;
  padding: 10px;
  width: 119px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;

export const StyledInputContainer = styled.div`
  position: relative;
  z-index: -1;
`;
